import React from 'react';
import CopyButton from '../../../components/CopyButton';
import { committedProducts } from '../lib/marketReportsV1';
import { Field, Panel } from './primitives';

/**
 * The settlement period, read off the settled rows (`end − start`): the retailer realm has no
 * battery-level metadata route, so the period is what the writer settles at.
 */
export const settlementMinutes = reports => {
    for (const r of reports) {
        const minutes = (Date.parse(r.end) - Date.parse(r.start)) / 60000;
        if (Number.isFinite(minutes) && minutes > 0) {
            return Math.round(minutes);
        }
    }
    return null;
};

// Name, id, price area, product, period, devices. The products and the period are derived
// from the settled delivery rows rather than read from the battery: the retailer realm has no
// battery metadata route, and the settled record is what the battery actually sold. An
// up-and-down battery reads as its two markets — FCR-D up and FCR-D down — never as the
// internal up-and-down construct.
const BasicProperties = ({ battery, reports, reportsReady }) => {
    const products = committedProducts(reports);
    const period = settlementMinutes(reports);
    const derived = value => (reportsReady ? value : '…');
    return (
        <Panel icon="fa-circle-info" title="Basic properties">
            <div className="gw-card__grid vb-grid--4">
                <Field label="Name" value={battery.name} />
                <Field
                    label="Id"
                    node={
                        <span className="vb-page__id">
                            {battery.id}
                            <CopyButton value={battery.id} />
                        </span>
                    }
                />
                <Field label="Price area" value={battery.priceArea} mono />
                <Field
                    label={products.length > 1 ? 'Products' : 'Product'}
                    node={
                        products.length > 0 ? (
                            <span>
                                {products.map((product, i) => (
                                    <React.Fragment key={product.label}>
                                        {i > 0 ? ' · ' : null}
                                        <span className="vb-product" style={{ color: product.color }}>
                                            {product.label}
                                        </span>
                                    </React.Fragment>
                                ))}
                            </span>
                        ) : (
                            derived(reports.length === 0 ? '—' : 'nothing committed')
                        )
                    }
                />
                <Field label="Period" value={derived(period === null ? null : `${period} min`)} mono />
                <Field label="Devices" value={String(battery.members.length)} />
            </div>
            <p className="gw-card__foot">Products and period are read off the last 7 days of settled delivery reports.</p>
        </Panel>
    );
};

export default BasicProperties;
